import api from "./axios";

// GET /api/users caps per_page at 100, so a bigger request silently returns only the first 100 users.
const PER_PAGE = 100;

/**
 * Every user the caller may list (id, name, email for pickers; full rows for admins), fetched page by page.
 */
export async function fetchAllUsers() {
  const users = [];
  let page = 1;
  let lastPage = 1;

  do {
    const res = await api.get("/api/users", { params: { per_page: PER_PAGE, page } });
    users.push(...(res.data?.data || []));
    lastPage = Number(res.data?.last_page) || 1;
    page += 1;
  } while (page <= lastPage);

  return users;
}
